import {
  Component,
  OnInit,
  Input,
  ContentChild,
  Output,
  EventEmitter,
} from "@angular/core";

import { MatDialogRef } from "@angular/material/dialog";
import { getTranslation } from "../../utils/utils";

@Component({
  selector: "rs-common-dialog",
  styleUrls: ["./index.component.scss"],
  templateUrl: "./index.component.html",
})
export class CommonDialogComponent implements OnInit {
  public translation;

  // 隐藏元素相关属性
  @Input() hideHeader = false;
  @Input() hideCloseIcon = false;
  @Input() hideCloseBtn = false;
  @Input() hideSaveBtn = false;
  @Input() hideDiscardBtn = true;
  @Input() saveBtnLabel = "";
  @Input() cancelBtnLabel = "";
  @Input() discardBtnLabel = "";
  @Input() showErrorIcon = false;
  @Input() showZoomBtn = false;
  @Input() customSave = false;
  @Input() customPageTitle = false;

  // 关闭前的回调函数
  @Input() onCloseRequest: Function;

  // 显示相关属性
  @Input() dialogStyle = {};
  @Input() size = "";
  @Input() title = "Dialog";
  @Input() loading = false;
  @Output() saveEmit: EventEmitter<Function> = new EventEmitter<Function>();
  @Output() closeEmit: EventEmitter<Function> = new EventEmitter<Function>();

  defaultSize: string = "";
  constructor(public dialogRef: MatDialogRef<CommonDialogComponent>) { }

  // 控制底部插槽有内容时隐藏默认按钮
  @ContentChild("footerSlot", { static: false }) footerContent: any;
  customFooter: boolean = false;
  ngAfterContentInit() {
    this.customFooter = !!this.footerContent;
  }

  ngOnInit() {
    this.getInfo();
  }

  onClose() {
    if (this.onCloseRequest) {
      this.onCloseRequest().then((confirmed) => {
        if (confirmed) {
          this.dialogRef.close("close");
        }
      });
    } else {
      this.dialogRef.close("close");
    }
  }

  onZoom() {
    if (this.size === "largest") {
      this.size = this.defaultSize; // 恢复到原始大小
    } else {
      this.size = "largest"; // 设置为最大化
    }
  }

  onSave() {
    if (this.customSave) {
      this.saveEmit.emit();
    } else {
      this.dialogRef.close("save");
    }
  }

  onDiscard() {
    this.dialogRef.close("discard");
  }

  private getInfo() {
    this.translation = getTranslation();
    this.saveBtnLabel = this.saveBtnLabel || this.translation.SAVE || ".SAVE";
    this.cancelBtnLabel =
      this.cancelBtnLabel || this.translation.CANCEL || ".CANCEL";
    this.defaultSize = this.size;
  }
}
